export default "__VITE_ASSET__Dzz8Hlr4__"